import { RootState } from 'src/store/store';
import { useSelector } from 'react-redux';

import useLoginState from '@hooks/useLoginState';
import { getLabelFallback } from '@utils/utils';
import NewPrescriptionForm from '../prescription-form/NewPrescriptionForm';
import InfoIconSmall from '@images/svg-icons/infoIconSmall.svg';

interface Props {
    showNoPrescriptionsAlert: boolean;
}

const AddNewPrescription = ({ showNoPrescriptionsAlert }: Props) => {
    const currentProduct = useSelector((state: RootState) => state.contacts.currentProduct);
    const { isLoggedIn, login } = useLoginState();

    const loginErrorHandler = () => {
        console.error('Could not log in'); // TODO: show error?
    };

    return (
        <div className="contact-lens-prescription logged-select-prescription">
            {showNoPrescriptionsAlert && (
                <div className="alert">
                    <InfoIconSmall className="icon" />

                    <span className="text">
                        {getLabelFallback('MYPROFILE_NO_PRESCRIPTION_SAVED_PT1')}
                        {getLabelFallback('MYPROFILE_NO_PRESCRIPTION_SAVED_PT2')}
                    </span>
                </div>
            )}

            <div className="contact-lens-prescription-title">
                {isLoggedIn === 'LOGGED' ? (
                    getLabelFallback('CONTACT_LENSES_PRESCRIPTION_INFO_LOGGED')
                ) : (
                    <>
                        {getLabelFallback('CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT1')}{' '}
                        <span>
                            <button
                                className="login-text-button"
                                onClick={() => login(loginErrorHandler)}
                            >
                                {getLabelFallback('SIGN_IN')}
                            </button>
                        </span>{' '}
                        {getLabelFallback('CONTACT_LENSES_PRESCRIPTION_INFO_GUEST_PT2')}
                    </>
                )}
            </div>

            {!!currentProduct && <NewPrescriptionForm />}
        </div>
    );
};

export default AddNewPrescription;
